import React from 'react';
import { AlertTriangle } from 'lucide-react';

const CrisisDisclaimer = ({ variant = 'default' }) => {
  if (variant === 'footer') {
    return (
      <div className="bg-white/5 rounded-xl p-4 mt-8" data-testid="crisis-disclaimer-footer">
        <div className="flex items-start gap-3">
          <AlertTriangle size={18} className="text-amber-400 flex-shrink-0 mt-0.5" />
          <p className="text-xs text-white/70 leading-relaxed">
            <span className="font-medium text-white/90">Important:</span> Mental Health Services are not suited during a crisis. Please contact a local emergency service in case of immediate distress.
          </p>
        </div>
      </div>
    );
  }

  if (variant === 'compact') {
    return (
      <div className="bg-amber-50 border border-amber-200 rounded-xl p-4" data-testid="crisis-disclaimer-compact">
        <div className="flex items-start gap-3">
          <AlertTriangle size={18} className="text-amber-600 flex-shrink-0 mt-0.5" />
          <p className="text-sm text-amber-800">
            <span className="font-medium">Important:</span> Mental Health Services are not suited during a crisis. Please contact a local emergency service in case of immediate distress.
          </p>
        </div>
      </div>
    );
  }

  // Default variant - more prominent
  return (
    <div className="bg-amber-50 border border-amber-200 rounded-2xl p-6" data-testid="crisis-disclaimer">
      <div className="flex items-start gap-4">
        <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
          <AlertTriangle size={20} className="text-amber-600" />
        </div>
        <div>
          <h4 className="font-medium text-amber-900 mb-1">Important Notice</h4>
          <p className="text-sm text-amber-700 leading-relaxed">
            Mental Health Services are not suited during a crisis. Please contact a local emergency service in case of immediate distress.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CrisisDisclaimer;
